module.exports = __webpack_public_path__ + "static/art2-d3e5b7e19da04737e763def19fc39907.jpg";